"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Defined as a stub in support of Create template/copyTemplate action
 * https://jira.cvent.com/browse/STUD-1970
 *
 * TODO: migrate from app.studio.director
 */
function addTemplateToOverlays() {}
var _default = exports["default"] = addTemplateToOverlays;